__turbopack_context__.v({
  "divider": "M0WnvG_divider",
  "wrapper": "M0WnvG_wrapper",
});
